// extracted by mini-css-extract-plugin
module.exports = {"interested-products":"interestedProducts_interested-products__JOdUG","title":"interestedProducts_title__jNxpH"};